/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-02T18:37:11.524
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'smallapplication-invoicetoolsinvoice-'

export default 
{
path: '/smallapplication/invoicetoolsinvoice',
name: 'smallapplication-invoicetoolsinvoice',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}invoicetoolsinvoice-index',

meta:{
...meta,
title: '开票信息'
},

component: () => import('@/pages/smallapplication/invoicetoolsinvoice/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}invoicetoolsinvoice-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '开票信息编辑'
},

component: () => import('@/pages/smallapplication/invoicetoolsinvoice/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}invoicetoolsinvoicedetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '开票信息新增'
},

component: () => import('@/pages/smallapplication/invoicetoolsinvoice/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}invoicetoolsinvoiceView',
auth: [
'hidden'
],

meta:{
...meta,
title: '开票信息详情查看'
},

component: () => import('@/pages/smallapplication/invoicetoolsinvoice/detail-view') ,
},
]
};
